import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__ from "../lib/utils.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__button_mjs_ee878bc8__ from "./button.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__calendar_mjs_1a75f28e__ from "./calendar.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__popover_mjs_66cb72c6__ from "./popover.mjs";
import * as __WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__ from "lucide-react";
import * as __WEBPACK_EXTERNAL_MODULE_date_fns_925206bc__ from "date-fns";
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
const QUICK_LINKS = [
    {
        label: "Today",
        value: "today",
        getRange: ()=>({
                start: new Date(),
                end: new Date()
            })
    },
    {
        label: "Yesterday",
        value: "yesterday",
        getRange: ()=>({
                start: (0, __WEBPACK_EXTERNAL_MODULE_date_fns_925206bc__.subDays)(new Date(), 1),
                end: (0, __WEBPACK_EXTERNAL_MODULE_date_fns_925206bc__.subDays)(new Date(), 1)
            })
    },
    {
        label: "Week to Date",
        value: "week_to_date",
        getRange: ()=>({
                start: (0, __WEBPACK_EXTERNAL_MODULE_date_fns_925206bc__.startOfWeek)(new Date()),
                end: new Date()
            })
    },
    {
        label: "Month to Date",
        value: "month_to_date",
        getRange: ()=>({
                start: (0, __WEBPACK_EXTERNAL_MODULE_date_fns_925206bc__.startOfMonth)(new Date()),
                end: new Date()
            })
    },
    {
        label: "Quarter to Date",
        value: "quarter_to_date",
        getRange: ()=>({
                start: (0, __WEBPACK_EXTERNAL_MODULE_date_fns_925206bc__.startOfQuarter)(new Date()),
                end: new Date()
            })
    },
    {
        label: "Year to Date",
        value: "year_to_date",
        getRange: ()=>({
                start: (0, __WEBPACK_EXTERNAL_MODULE_date_fns_925206bc__.startOfYear)(new Date()),
                end: new Date()
            })
    },
    {
        label: "Last 7 Days",
        value: "last_7_days",
        getRange: ()=>({
                start: (0, __WEBPACK_EXTERNAL_MODULE_date_fns_925206bc__.subDays)(new Date(), 7),
                end: new Date()
            })
    },
    {
        label: "Last 30 Days",
        value: "last_30_days",
        getRange: ()=>({
                start: (0, __WEBPACK_EXTERNAL_MODULE_date_fns_925206bc__.subDays)(new Date(), 30),
                end: new Date()
            })
    }
];
function DateRangePicker({ startDate, endDate, onChange, initialSettings, onSettingsChange, ...props }) {
    var _QUICK_LINKS_find;
    const [activePreset, setActivePreset] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)();
    (0, __WEBPACK_EXTERNAL_MODULE_react__.useEffect)(()=>{
        if (initialSettings) {
            if (initialSettings.preset) {
                const quickLink = QUICK_LINKS.find((link)=>link.value === initialSettings.preset);
                if (quickLink) {
                    setActivePreset(initialSettings.preset);
                    const range = quickLink.getRange();
                    onChange(range);
                }
            } else if (initialSettings.startDate && initialSettings.endDate) {
                setActivePreset(void 0);
                onChange({
                    start: (0, __WEBPACK_EXTERNAL_MODULE_date_fns_925206bc__.parseISO)(initialSettings.startDate),
                    end: (0, __WEBPACK_EXTERNAL_MODULE_date_fns_925206bc__.parseISO)(initialSettings.endDate)
                });
            }
        }
    }, [
        initialSettings,
        onChange
    ]);
    const handleDateChange = (range)=>{
        setActivePreset(void 0);
        onChange(range);
        if (onSettingsChange) onSettingsChange({
            startDate: range.start.toISOString(),
            endDate: range.end.toISOString()
        });
    };
    const handlePresetClick = (link)=>{
        setActivePreset(link.value);
        const range = link.getRange();
        onChange(range, link.label);
        if (onSettingsChange) onSettingsChange({
            preset: link.value
        });
    };
    const currentYear = new Date().getFullYear();
    const maxDays = (0, __WEBPACK_EXTERNAL_MODULE_date_fns_925206bc__.isLeapYear)(currentYear) ? 366 : 365;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__popover_mjs_66cb72c6__.Popover, {
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__popover_mjs_66cb72c6__.PopoverTrigger, {
                asChild: true,
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__button_mjs_ee878bc8__.Button, {
                    variant: "outline",
                    className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("tw-w-fit tw-justify-start tw-text-left tw-font-normal tw-text-xs tw-text-gray-500", !startDate && !endDate && "tw-text-muted-foreground"),
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.CalendarIcon, {
                            className: "tw-mr-2 tw-h-4 tw-w-4 tw-text-gray-500"
                        }),
                        activePreset ? (null === (_QUICK_LINKS_find = QUICK_LINKS.find((link)=>link.value === activePreset)) || void 0 === _QUICK_LINKS_find ? void 0 : _QUICK_LINKS_find.label) || `${(0, __WEBPACK_EXTERNAL_MODULE_date_fns_925206bc__.format)(startDate, "MM/dd/yy")} - ${(0, __WEBPACK_EXTERNAL_MODULE_date_fns_925206bc__.format)(endDate, "MM/dd/yy")}` : startDate && endDate ? `${(0, __WEBPACK_EXTERNAL_MODULE_date_fns_925206bc__.format)(startDate, "MM/dd/yy")} - ${(0, __WEBPACK_EXTERNAL_MODULE_date_fns_925206bc__.format)(endDate, "MM/dd/yy")}` : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
                            children: "Select a range"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__popover_mjs_66cb72c6__.PopoverContent, {
                side: "bottom",
                align: "start",
                sideOffset: 4,
                className: "tw-w-auto tw-p-0 tw-flex tw-flex-col md:tw-flex-row",
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                        className: "tw-flex tw-justify-center tw-p-3",
                        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__calendar_mjs_1a75f28e__.Calendar, {
                            mode: "range",
                            selected: {
                                from: startDate,
                                to: endDate
                            },
                            onSelect: (range)=>{
                                if ((null == range ? void 0 : range.from) && (null == range ? void 0 : range.to)) handleDateChange({
                                    start: range.from,
                                    end: range.to
                                });
                            },
                            min: 0,
                            max: maxDays,
                            ...props
                        })
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                        className: "tw-border-t md:tw-border-t-0 md:tw-border-l tw-border-gray-100 tw-w-full md:tw-w-[150px] tw-p-3",
                        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                            className: "tw-flex tw-flex-row md:tw-flex-col tw-flex-wrap tw-gap-1",
                            children: [
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("p", {
                                    className: "tw-text-xs tw-text-gray-600 tw-text-center tw-font-bold tw-w-full tw-pt-4",
                                    children: "Date Ranges"
                                }),
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                                    className: "tw-grid tw-grid-cols-2 md:tw-grid-cols-1 tw-gap-1 tw-w-full",
                                    children: QUICK_LINKS.map((link)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__button_mjs_ee878bc8__.Button, {
                                            variant: activePreset === link.value ? "dark" : "ghost",
                                            className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("!tw-h-8 !tw-justify-start", "tw-text-xs tw-text-left", activePreset === link.value ? "tw-text-white" : "tw-text-gray-600 hover:tw-text-gray-900 hover:tw-bg-gray-50"),
                                            onClick: ()=>handlePresetClick(link),
                                            children: link.label
                                        }, link.label))
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
export { DateRangePicker };

//# sourceMappingURL=date-range-picker.mjs.map